import React from 'react'
import { SvgIcon } from '@material-ui/core'

export default function NmkIcon() {
  return (
    <SvgIcon>
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        preserveAspectRatio="xMidYMid meet"
      >
<g>
	<path d="M7.62,3.95c1.19,1.2,2.39,2.41,3.58,3.6c-1.19,1.19-2.39,2.4-3.59,3.6c-1.19-1.2-2.39-2.4-3.59-3.6
		C5.21,6.35,6.41,5.15,7.62,3.95z"/>
	<path d="M8.6,11.87c1.19-1.19,2.4-2.4,3.6-3.61c1.2,1.2,2.4,2.41,3.6,3.61c-1.19,1.2-2.4,2.41-3.59,3.61
		C11,14.28,9.79,13.07,8.6,11.87z"/>
	<path d="M12.83,16.42c1.19-1.19,2.39-2.4,3.59-3.6c1.2,1.21,2.41,2.41,3.61,3.62c-1.2,1.2-2.4,2.41-3.59,3.6
		C15.23,18.82,14.03,17.61,12.83,16.42z"/>
	<path d="M16.33,3.79c1.19,1.19,2.38,2.39,3.57,3.59c-2.38,0-4.77,0-7.15,0C13.95,6.17,15.14,4.98,16.33,3.79z"/>
	<path d="M8.44,20.45c1.19-1.2,2.39-2.4,3.59-3.6c1.19,1.19,2.39,2.4,3.59,3.6C13.22,20.45,10.83,20.45,8.44,20.45z"/>
	<path d="M7.69,20.19C6.52,19,5.32,17.8,4.13,16.61c2.39,0,4.78,0,7.14,0C10.09,17.79,8.9,18.99,7.69,20.19z"/>
	<path d="M12,7.12c-1.19-1.19-2.38-2.39-3.58-3.59c2.4,0,4.79,0,7.16,0C14.4,4.71,13.2,5.91,12,7.12z"/>
</g>    </svg>
    </SvgIcon>
  )
}
